/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".error-page__text[_ngcontent-%COMP%]{margin-bottom:20px}.error-page__url[_ngcontent-%COMP%]{display:block;margin-bottom:20px;padding:10px;background-color:#eefaff;font-size:1.4em;overflow-x:auto;overflow-y:hidden}.error-page__link-list[_ngcontent-%COMP%]{margin:20px 0 30px;font-size:1.2em;line-height:1.5em}.error-page__error-code[_ngcontent-%COMP%]{color:#bed2d2}"];
export { styles as styles };
